import CustomView, {
    CustomViewInput,
} from "@/domain/entities/customViews/CustomView";
import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import {
    CustomViewInput as CustomViewInputSDK,
    CustomView as CustomViewSDK,
    EmailDisplayMode as EmailDisplayModeSDK,
} from "@cs_teamwaydev/mailvista-sdk_react";
import {
    viewFilterToDomainMapper,
    viewFilterToSDKMapper,
} from "./viewFilterMapper";
import {
    viewWidgetSettingsToDomainMapper,
    viewWidgetSettingsToSDKMapper,
} from "./viewWidgetSettingsMapper";

export const customViewToDomainMapper = (
    customView: CustomViewSDK,
): CustomView =>
    new CustomView({
        id: customView.id,
        userId: customView.userId,
        name: customView.name,
        icon: customView.icon,
        filters: viewFilterToDomainMapper(customView.filters),
        displayMode: EmailDisplayMode[customView.displayMode],
        widgets: viewWidgetSettingsToDomainMapper(customView.widgets),
        createdAt: customView.createdAt
            ? new Date(customView.createdAt)
            : new Date(),
        updatedAt: customView.updatedAt
            ? new Date(customView.updatedAt)
            : new Date(),
        isFavorite: customView.isFavorite,
        displayOrder: customView.displayOrder,
        userPrompt: customView.userPrompt,
        noteContent: customView.noteContent,
        internetMessageIds: customView.internetMessageIds,
    });

export const customViewToSDKMapper = (
    customView: CustomView,
): CustomViewSDK => ({
    id: customView.id,
    userId: customView.userId,
    name: customView.name,
    viewType: customView.viewType,
    icon: customView.icon,
    filters: viewFilterToSDKMapper(customView.filters),
    displayMode: customView.displayMode as EmailDisplayModeSDK,
    widgets: viewWidgetSettingsToSDKMapper(customView.widgets),
    createdAt: customView.createdAt.toISOString(),
    updatedAt: customView.updatedAt.toISOString(),
    isFavorite: customView.isFavorite,
    displayOrder: customView.displayOrder,
    userPrompt: customView.userPrompt,
    noteContent: customView.noteContent,
    internetMessageIds: customView.internetMessageIds,
    // Le web n'affiche que des mails déjà ordonnés : la composition datée ne lui sert pas.
    mails: [],
});

export const customViewInputToSDKMapper = (
    customView: CustomViewInput,
): CustomViewInputSDK => ({
    id: customView.id,
    userId: customView.userId,
    name: customView.name,
    icon: customView.icon,
    filters: viewFilterToSDKMapper(customView.filters),
    displayMode: customView.displayMode as EmailDisplayModeSDK,
    widgets: viewWidgetSettingsToSDKMapper(customView.widgets),
    userPrompt: customView.userPrompt,
    noteContent: customView.noteContent,
    internetMessageIds: customView.internetMessageIds,
});
